import React from 'react';
import styled, { css } from 'styled-components';
import { DEVICE_SIZE, mq } from '../../utils/mq';
import { useLinkComponent } from '../../utils/component';
import { useTranslation } from '../../utils/translation';

const Wrapper = styled.div`
  box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  line-height: 24px;
  margin: 15px 0;
  padding: 15px;

  ${mq.gte(
    DEVICE_SIZE.LARGE,
    css`
      margin: 30px 60px;
      padding: 30px;
    `,
  )}
`;

const Button = styled.div`
  border-radius: 6px;
  background: rgba(0, 158, 118, 0.5);
  color: white;
  font-family: var(--theme-typography-primary-font);
  font-weight: 700;
  margin: 10px 0 0;
  padding: 15px 25px;
  text-align: center;

  &.mod-margin {
    margin: 10px 0 30px;
  }

  ${mq.gte(
    DEVICE_SIZE.LARGE,
    css`
      font-size: 24px;
    `,
  )}
`;

const Content = styled.p`
  margin: 0 0 10px;

  a {
    text-decoration: underline;
    transition: color 0.3s ease;

    &:hover {
      color: var(--theme-color-primary);
    }
  }
`;

const List = styled.ul`
  margin: 0 0 10px;
  padding-left: 20px;

  ${mq.gte(
    DEVICE_SIZE.LARGE,
    css`
      margin: 0 0 30px;
    `,
  )}
`;

const ListItem = styled.li``;

export type DownloadFinishedType = {
  file: {
    url: string;
    externalLinkOnly: boolean;
  };
  name: string;
};

export const DownloadFinished = ({ file, name }: DownloadFinishedType) => {
  const LinkComponent = useLinkComponent();
  const t = useTranslation();

  return (
    <>
      <Button className={file.externalLinkOnly ? 'mod-margin' : ''}>
        {file.externalLinkOnly
          ? t('design.download.finished.titleExternalLink', { software: name })
          : t('design.download.finished.title')}
      </Button>
      {!file.externalLinkOnly && (
        <Wrapper>
          <Content>{t('design.download.finished.locate')}</Content>
          <List>
            <ListItem>{t('design.download.finished.locateOne')}</ListItem>
            <ListItem>{t('design.download.finished.locateTwo')}</ListItem>
          </List>
          <Content>{t('design.download.finished.install')}</Content>
          <List>
            <ListItem>{t('design.download.finished.installOne')}</ListItem>
            <ListItem>{t('design.download.finished.installTwo')}</ListItem>
          </List>
          <Content>
            {t('design.download.finished.manually')},{' '}
            <LinkComponent href={file.url}>{t('design.download.finished.manuallyLink')}</LinkComponent>
          </Content>
        </Wrapper>
      )}
    </>
  );
};
